<template>
  <el-upload
    :file-list="picture"
    :action="uploadUrl"
    :on-success="handlePictureCardPreview"
    :on-remove="handleRemove"
    :headers="headers"
    name="files"
    :limit="1"
    :multiple="false"
    accept=".wav,.mp3"
  >
    <div class="uploadClass">
      <el-button type="primary" plain>上传音频文件</el-button>
      <div class="tips">
        音频支持:.wav.mp3格式，时长不超过30分钟大小不超过100MB
      </div>
    </div>
  </el-upload>
</template>

<script>
export default {
  props: {
    value: {
      type: Object,
      default: {},
    },
  },
  data() {
    return {
      picture: [],
      headers: {
        Authorization: localStorage.getItem("token"),
      },
      uploadUrl: process.env.VUE_APP_API + "/api/common/fileInfo/newUpload",
    };
  },
  mounted() {
    this.picture = this.value.url ? [this.value] : [];
  },
  methods: {
    handlePictureCardPreview(response, file) {
      if (Array.isArray(response.data) && response.data.length > 0) {
        this.picture = response.data.map((item) => ({
          url: item.fileUrl, // 直接提取 url 字段
          name: file.name,
        }));
        console.log(this.picture[0]);
        
        this.$emit("success", this.picture[0]);
      }
    },
    handleRemove() {
      // 删除图片
      this.picture = [];
    },
  },
};
</script>

<style scoped lang="scss">
.uploadClass {
  display: flex;
  gap: 15px;
  align-items: center;

  .tips {
    color: rgba(172, 178, 195, 1);
    font-size: 12px;
  }
}
</style>
